import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

import { NgbAlertModule } from '@ng-bootstrap/ng-bootstrap';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { NgSelectModule } from '@ng-select/ng-select';

import { UIModule } from '../../shared/ui/ui.module';
import { LoginComponent } from './login/login.component';
import { SignupComponent } from './signup/signup.component';
import { VerifyComponent } from './verify/verify.component';

import { AuthRoutingModule } from './auth-routing';
import { PasswordresetComponent } from './passwordreset/passwordreset.component';

import { NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { ArchwizardModule } from 'angular-archwizard';

import { AgmCoreModule } from '@agm/core';
 
@NgModule({
  declarations: [LoginComponent, SignupComponent, PasswordresetComponent, VerifyComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    NgbAlertModule,
    UIModule,
    AuthRoutingModule, 
    CarouselModule,
    NgbNavModule,
    NgSelectModule,
    ArchwizardModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyBzCU795ZIE7glpEbOU18uos6sRGtKT7E0'
    }),
  ]
})
export class AuthModule { }
